import { defineComponent, h, PropType } from 'vue';

export default defineComponent({
  props: {
    json: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props) {
    return () => h('script', {
      type: 'application/ld+json',
      innerHTML: props.json,
    });
  },
});
